<template>
  <div class="table10">
    <el-table :data="list" height="850" style="width: 100%" ref="table" @sort-change='sortChange'>
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.ths_stock_short_name_stock }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{scope.row.a_code || '--'}}/{{scope.row.h_code || '--'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="that_contrast_price" label="比价(H/A)" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.that_contrast_price || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="that_a_latest" label="A股价格" align="center" sortable='custom'>
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{ colorRed: scope.row.that_a_change_ratio && scope.row.that_a_change_ratio > 0, colorGreen: scope.row.that_a_change_ratio && scope.row.that_a_change_ratio < 0,}">{{ scope.row.that_a_latest || '--'}}</div>
          <div style="font-size: 10px" :class="{colorRed: scope.row.that_a_change_ratio && scope.row.that_a_change_ratio > 0, colorGreen: scope.row.that_a_change_ratio && scope.row.that_a_change_ratio < 0,}">{{ scope.row.that_a_change_ratio || '--'}} <i v-if="scope.row.that_a_change_ratio">%</i></div>
        </template>
      </el-table-column>
      <el-table-column prop="that_h_latest_hk" label="H股价格(港元)" align="center" sortable='custom'>
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{colorRed: scope.row.that_h_change_ratio && scope.row.that_h_change_ratio > 0,colorGreen: scope.row.that_h_change_ratio && scope.row.that_h_change_ratio < 0,}">{{ scope.row.that_h_latest_hk || '--'}}</div>
          <div style="font-size: 10px" :class="{colorRed: scope.row.that_h_change_ratio && scope.row.that_h_change_ratio > 0,colorGreen: scope.row.that_h_change_ratio && scope.row.that_h_change_ratio < 0,}">{{ scope.row.that_h_change_ratio || '--'}} <i v-if="scope.row.that_h_change_ratio">%</i></div>
        </template>
      </el-table-column>
      <el-table-column prop="that_h_latest_rmb" label="H股价格(元)" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.that_h_latest_rmb || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" align="center">
        <template>
          <img src="../../../../public/img/index3/add.png" alt="" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {AHcontrastList} from '../../../http/index.js'
export default {
  props:{
    
  },
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{
        
      },

    };
  },

  mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number,type:2},obj)
      AHcontrastList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
          this.$emit('getinfo3',res.data.total_data)
        }else{
          this.list = this.list.concat(res.data.list)
        }
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table10 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
::-webkit-scrollbar-thumb {
  width: 0 !important;
  height: 0 !important;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}

.table10 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table10 /deep/ .cell{
  padding: 0;
}
.table10 /deep/ .el-table th.el-table__cell>.cell{
  padding:  0;
}
</style>